import { LucideIcon } from 'lucide-react'
import React, { memo, useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import styles from '~/styles/NodeCustomActions.module.css'
import { CustomButton } from '../interfaces/CustomButton'

const NodeCustomActions: React.FC<{
  buttons: CustomButton[]
  nodeId: string
}> = ({ buttons, nodeId }) => {
  // Detect dark mode
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    // Check for dark mode on component mount
    const checkDarkMode = () => {
      setIsDarkMode(
        document.documentElement.getAttribute('data-theme') === 'dark'
      )
    }

    // Initial check
    checkDarkMode()

    // Create an observer to detect theme changes
    const observer = new MutationObserver(checkDarkMode)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div className={styles.nodeCustomActions}>
      {buttons?.map((button) => (
        <TooltipProvider key={`customactionsbutton-${nodeId}-${button.id}`}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                onClick={button.onClick}
                className={`custom-actionbutton-${nodeId}-${button.id} z-20 ${styles.nodeActionButton}`}
                variant="ghost"
                size="icon"
              >
                {button.icon}
              </Button>
            </TooltipTrigger>
            {button.tooltip && (
              <TooltipContent side="bottom">{button.tooltip}</TooltipContent>
            )}
          </Tooltip>
        </TooltipProvider>
      ))}
    </div>
  )
}

export default memo(NodeCustomActions)
